import { useContext } from 'react';
import { HttpClientContext } from './httpClientContext';

export function useHttpClient() {
  return useContext(HttpClientContext);
}
